import styled from "styled-components";

export const Body = styled.div`
  padding: 4px 18px 8px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 12px 18px calc(16px + env(safe-area-inset-bottom));
`;
